/**
 * @requires  datumPayDialog.mod  common_function.js  jQuery
 */
import "../../common/prefixName.js"
import Utils from "../../../common/utils"
import dialogContent from '../../html/content_module/datumPayDialog.mod';
import payComp from './payComp';
import couponBizTypeEnum from '../../data/couponBizTypeEnum';
import externalApp from "../../data/externalApp";

var apiBaseUrl = Link.prefix.realmName;

$(document.body).append(dialogContent);

var config = {
    apiConfig : {
        submitOrder : {
            // url : "portal/order/pay/prepay_video_on_demand",
            url : apiBaseUrl + "portal/order/pay/prepay_download_for_reserve",
            method : 'post',
            idName : 'downloadId'
        },
        getPayStatus : {
            url : apiBaseUrl + "portal/order/pay/update_order_status",
            method : 'post'
        },
        couponList : {
            url : apiBaseUrl + "portal/v2/coupon/getUseCouponsList",
            params : {
                bizId : '',
                orderBizType : couponBizTypeEnum.DATUM.code
            }
        },

    }
};

var helper = new Vue({
    el : '#datumPayDialog',
    extends : payComp,
    data : {
        apiConfig : config.apiConfig,
        visible : false,
        contents : {
            pay : {
                title : '确认支付'
            },
            coupon : {
                title : '选择优惠券'
            }
        },
        currentContent : null,

        agreeServiceName : '师讯平台资料下载须知',
        agreeServiceUrl : externalApp.newShixun.baseUrl + 'index.html#/help/agreement/datum_download_agreement',
    },
    methods : {
        open : function (){
            showMask();
            this.visible = true;
            // $(this.$el).fadeIn();
        },
        close : function (){
            hideMask();
            this.visible = false;
            // $(this.$el).fadeOut();
        },
        goToDown : function () {
            let url = './download/paySuccess.html?id=' + this.orderId;
            // window.location.href = url;
            app.redirect(url);
        },
        onPaySuccess : function (result, orderId) {
            // this.goToDown();

            //let url = externalApp.newShixun.baseUrl + 'index.html#/integral/receiveIntegralAfterPay/' + orderId;
            let url = externalApp.newShixun.baseUrl + 'index.html#/orderForm';
            app.redirect(url);
        },
        formatDateTime : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment().format('YYYY.MM.DD');
        }
    }
});

export default helper;



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/datumPayDialog.js
 **/